export const siteConfig = {
  name: "黑料百科",
  tagline: "事件详解 · 事件背景 · 完整记录",
  description:
    "黑料百科是一个以事件词条方式整理网络热点的知识库，按背景、时间线与完整记录梳理每一个瓜条的来龙去脉，倡导理性看待、不信谣不传谣。",
  email: "hello@heiliaowiki.example",
  workEmail: "cooperation@heiliaowiki.example",
  slogan: "一网打尽每一个瓜条背后的脉络",
};

export const navItems = [
  { label: "首页", href: "/" },
  { label: "事件词条库", href: "/entries" },
  { label: "关于我们", href: "/about" },
  { label: "联系我们", href: "/contact" },
];

export const stats = [
  { label: "收录词条", value: "1,286" },
  { label: "覆盖话题", value: "36" },
  { label: "平均更新周期", value: "48h" },
  { label: "读者评分", value: "4.9" },
];